import * as React from 'react';
import { Button, Col, Layout, Popconfirm, Row } from 'antd';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import {
	compareStrings,
	getObjectValues,
	isHierarchyNTEBased,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import SubnavBar from '../subnav_bar/SubnavBar';
import { fetchFacilityActiveBuyerUsersAndInternalSupplierUsers } from '../../thunks/users_thunks';
import ModalHeaderSteps from '../modal_header_steps_component/modalHeaderSteps';
import {
	approvalsRestCrudThunksForBuyer,
	approvalsRestCrudThunksForSupplier,
	deleteBuyerCompanyApprovalTiers,
	editBuyerCompanyApprovalTiers,
	getBuyerCompanyApprovalTiers,
	patchBuyerCompanyApprovalTiers,
	updateBuyerCompanyApprovalTiers,
} from '../../thunks/company_approval_thunks';
import {
	companyConfigRestCrudThunks,
	companyConfigRestCrudThunksForBuyer,
	companyConfigRestCrudThunksForSupplier,
} from '../../thunks/company_config_thunks';
import { useEffect, useState } from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { ApprovalHierarchyEditTitle } from './ApprovalHierarchyEditTitle';
import ApprovalHierarchyEditTiers from './ApprovalHierarchyEditTiers';
import { ApprovalHierarchyEditUsers } from './ApprovalHierarchyEditUsers';
import { ApprovalHierarchyPreview } from './ApprovalHierarchyPreview';

const { Content } = Layout;

const style = require('./ApprovalHierarchyComponent.less');

function ApprovalHierarchyComponent({
	id,
	userType,
	fetchBuyerCompanyApprovalSettings,
	getApprovalHierarchy,
	updateBuyerCompanyApprovalSettings,
	patchBuyerCompanyApprovalSettings,
	editBuyerCompanyApprovalSettings,
	deleteBuyerCompanyApprovalSettings,
	getBuyerCompanyConfig,
	updateBuyerCompanyConfig,
	fetchBuyerUsers,

	currentUser,
	companyConfig,
	token,
	history,
	approvalHierarchies,
	users,

	companyConfigFetching,
	usersFetching,
}) {
	const modalNames = ['Title', 'Tiers', 'Users'];
	const [visibleModal, setVisibleModal] = useState(null);
	const [originalApprovalHierarchy, setOriginalApprovalHierarchy] = useState([]);
	const [editedApprovalHierarchy, setEditedApprovalHierarchy] = useState([]);
	const [initialLoading, setInitialLoading] = useState(false);
	const [isNTEBased, setIsNTEBased] = useState(true);

	const refreshTiers = () => {
		setInitialLoading(true);
		if (id) {
			getApprovalHierarchy(id).then((approvalHierarchy) => {
				setOriginalApprovalHierarchy(approvalHierarchy);
				setInitialLoading(false);
				setIsNTEBased(isHierarchyNTEBased(nullSafeGetOrElse('tierDetails', approvalHierarchy, [])));
			});
		} else {
			setOriginalApprovalHierarchy(null);
			setInitialLoading(false);
		}
	};
	useEffect(() => {
		refreshTiers();
	}, []);

	const loading = initialLoading;
	if (loading) {
		return <PageLoadingPlaceholder />;
	}

	const editClick = () => {
		setVisibleModal('Title');

		//Sets edited approval hierarchy to current approval hierarchy to start edit process (while preserving original edit values)
		setEditedApprovalHierarchy(originalApprovalHierarchy);
	};
	const onCancel = () => {
		setVisibleModal(null);
		//Reverts approval hierarchy to original approval hierarchy
		setEditedApprovalHierarchy(originalApprovalHierarchy);
		if (originalApprovalHierarchy) {
			setIsNTEBased(
				isHierarchyNTEBased(nullSafeGetOrElse('tierDetails', originalApprovalHierarchy, []))
			);
		}
	};

	const setApprovalHierarchyName = (name) => {
		setEditedApprovalHierarchy({
			...editedApprovalHierarchy,
			name: name,
		});
	};

	const setApprovalHierarchyTiers = (tiers) => {
		setEditedApprovalHierarchy({
			...editedApprovalHierarchy,
			tierDetails: tiers,
		});
	};

	const formatForAPI = (approvalHierarchy) => {
		const tiers = nullSafeGetOrElse('tierDetails', approvalHierarchy, []).map((tier) => {
			delete tier.id;
			delete tier.showSearch;
			if (!isNTEBased) {
				delete tier.amountUpto;
			}
			return {
				...tier,
				label: nullSafeGetOrElse('label', tier, 0).toString(),
			};
		});

		return {
			...approvalHierarchy,
			tierDetails: tiers,
		};
	};

	const submitApprovalTiers = () => {
		const obj = {
			buyerCompanyId: currentUser.facility.buyerCompanyId,
			...formatForAPI(editedApprovalHierarchy),
		};
		updateBuyerCompanyApprovalSettings(obj).then((result) => {
			setVisibleModal(null);
			history.push(`/buyer/approvalHierarchies/detail/templates/${result.id}/details`);
		});
	};

	const updateApprovalTiers = () => {
		const obj = {
			buyerCompanyId: currentUser.facility.buyerCompanyId,
			...formatForAPI(editedApprovalHierarchy),
		};
		editBuyerCompanyApprovalSettings(obj).then(() => {
			setVisibleModal(null);
			refreshTiers();
		});
	};
	const deleteApprovalTiers = (e) => {
		deleteBuyerCompanyApprovalSettings({}, nullSafeGet('id', originalApprovalHierarchy)).then(() =>
			history.goBack()
		);
	};

	const submit = originalApprovalHierarchy === null ? submitApprovalTiers : updateApprovalTiers;

	let steps = [
		{
			title: 'Set Title',
			isActive: compareStrings(visibleModal, 'Title'),
			icon: null,
		},
		{
			title: 'Set Approval Tiers',
			isActive: compareStrings(visibleModal, 'Tiers'),
			icon: null,
		},
		{
			title: 'Add Approvers',
			isActive: compareStrings(visibleModal, 'Users'),
			icon: null,
		},
	];

	let modalHeaderSteps = <ModalHeaderSteps steps={steps} />;

	return (
		<Content className="buyerApprovalSettingsPage">
			<LogOnMountWithStandardEventProperties eventType="Visited buyer admin approval settings page" />
			<Row type="flex" className="rowSpacing">
				<Col style={{ margin: 'auto' }} span={24}>
					<SubnavBar
						left={<div />}
						right={
							<div>
								<Button type="primary" size="large" onClick={editClick} style={{ marginRight: 12 }}>
									{originalApprovalHierarchy === null ? 'Create' : 'Edit'}
								</Button>
								{/*originalApprovalHierarchy !== null ? (
                                <Popconfirm
                                    onConfirm={deleteApprovalTiers}
                                    placement="bottomLeft"
                                    title="Are you sure you want to delete your approval tiers?"
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button danger style={{ marginRight: 12 }} size="large" type="primary">
                                        Delete
                                    </Button>
                                </Popconfirm>
                            ) : null*/}
							</div>
						}
					/>
				</Col>
			</Row>
			<ApprovalHierarchyEditTitle
				visible={compareStrings(visibleModal, 'Title')}
				width={600}
				title={modalHeaderSteps}
				approvalHierarchy={editedApprovalHierarchy}
				setApprovalHierarchyName={setApprovalHierarchyName}
				onNext={() => setVisibleModal('Tiers')}
				onCancel={onCancel}
			/>
			<ApprovalHierarchyEditTiers
				visible={compareStrings(visibleModal, 'Tiers')}
				width={600}
				title={modalHeaderSteps}
				approvalHierarchy={editedApprovalHierarchy}
				setApprovalHierarchyTiers={setApprovalHierarchyTiers}
				onBack={() => setVisibleModal('Title')}
				onNext={() => setVisibleModal('Users')}
				isNTEBased={isNTEBased}
				setIsNTEBased={setIsNTEBased}
			/>
			<ApprovalHierarchyEditUsers
				visible={compareStrings(visibleModal, 'Users')}
				width={600}
				title={modalHeaderSteps}
				approvalHierarchy={editedApprovalHierarchy}
				setApprovalHierarchyTiers={setApprovalHierarchyTiers}
				onBack={() => setVisibleModal('Tiers')}
				onSubmit={submit}
				isNTEBased={isNTEBased}
				currentUser={currentUser}
				userType={userType}
				token={token}
				style={style}
				users={users}
				companyConfigFetching={companyConfigFetching}
				usersFetching={usersFetching}
				getBuyerCompanyConfig={getBuyerCompanyConfig}
				updateBuyerCompanyConfig={updateBuyerCompanyConfig}
				companyConfig={companyConfig}
				fetchBuyerUsers={fetchBuyerUsers}
			/>
			<ApprovalHierarchyPreview
				approvalHierarchy={originalApprovalHierarchy}
				style={style}
				token={token}
				currentUser={currentUser}
				editClick={editClick}
				isNTEBased={isNTEBased}
			/>
		</Content>
	);
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	currentUser: state.session.currentUser,
	token: state.session.token,
	usersFetching: nullSafeGetOrElse('buyer_users.loading', state, false),
	users: [
		...getObjectValues(nullSafeGetOrElse('buyer_users.records', state, {})),
		...getObjectValues(nullSafeGetOrElse('supplier_users.records', state, {})),
	],
	approvalHierarchies: state.approval_hierarchies,
	approvalHierarchiesPatching: state.approval_hierarchies.patching,
	companyConfigFetching: state.company_config.fetching,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getApprovalHierarchy: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? approvalsRestCrudThunksForSupplier.readOne(id)
				: approvalsRestCrudThunksForBuyer.readOne(id)
		),
	fetchBuyerUsers: (type) =>
		dispatch(fetchFacilityActiveBuyerUsersAndInternalSupplierUsers(ownProps.userType, type)()),
	fetchBuyerCompanyApprovalSettings: (id) =>
		dispatch(getBuyerCompanyApprovalTiers(ownProps.userType, id)()),
	updateBuyerCompanyApprovalSettings: (tiers) =>
		dispatch(updateBuyerCompanyApprovalTiers(ownProps.userType, tiers)()),
	editBuyerCompanyApprovalSettings: (tiers) =>
		dispatch(editBuyerCompanyApprovalTiers(ownProps.userType, tiers)()),
	deleteBuyerCompanyApprovalSettings: (tiers, id) =>
		dispatch(deleteBuyerCompanyApprovalTiers(ownProps.userType, tiers, id)()),
	patchBuyerCompanyApprovalSettings: (id, mirrorId, type) =>
		dispatch(patchBuyerCompanyApprovalTiers(ownProps.userType, id, mirrorId, type)()),
	getBuyerCompanyConfig: (contact) =>
		dispatch(companyConfigRestCrudThunks(ownProps.userType, contact)),
	updateBuyerCompanyConfig: (settings) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? companyConfigRestCrudThunksForSupplier.update(settings)
				: companyConfigRestCrudThunksForBuyer.update(settings)
		),
});

const ApprovalHierarchyComponentWR = withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ApprovalHierarchyComponent)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ApprovalHierarchyComponentWR);
